export default function () {

	// modify --header-height css custom property when we scroll
	const options = {
		threshold: 1.0,
	}
	const scrollChecker = document.getElementById('scroll-checker');
	const header = document.querySelector('.site-header');
	// console.log('scrollChecker', scrollChecker);
	if (scrollChecker) {
		const observer = new IntersectionObserver((entries, options) => {
			entries.forEach((entry) => {
				// console.log('entry', entry);
				// if we've scrolled past 75px
				if (entry.intersectionRatio <= 0) {
					// console.log('header is out of view');
					// adjust css custom property --header-height
					document.documentElement.style.setProperty('--desktop-header-height', '65px');
					header?.classList.add('scrolled');
				}
				else {
					// console.log('header is in view');
					document.documentElement.style.setProperty('--desktop-header-height', '75px');
					header?.classList.remove('scrolled');
				}
			});
		})
		observer.observe(scrollChecker);
	}
}